// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.k0Z7ct {
  padding: 0;
  margin: var(--spacing-3, 24px) 0;
  background: transparent;
  font-family: var(--font-family-base);
}

.oWDs1f {
  height: 1px;
  background-color: #e5e7eb;
  margin: 24px 0;
}

.tI2EMU {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 24px;
  padding: 0 var(--spacing-3, 24px);
  margin: var(--spacing-3, 24px) 0 0 0;
}

.MOSS1h {
  font-size: var(--ibk-typography-fontSizeMd, 14px);
  font-weight: 400;
  color: #1f2937;
  white-space: nowrap;
  flex: 1;
}

.adkx2u {
  font-size: var(--ibk-typography-fontSizeMd, 14px);
  font-weight: 600;
  color: #1f2937;
  white-space: nowrap;
}

.tl0OMM {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
  margin-right: 24px;
}

.bOPkAg {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: var(--ibk-typography-fontSizeMd, 14px);
  color: #1f2937;
  white-space: nowrap;
}

.JiQ3TS {
  width: 16px;
  height: 16px;
  margin: 0;
  cursor: pointer;
}

.sdtF85 {
  user-select: none;
}

.tClOva {
  width: auto !important;
  min-width: 100px !important;
  max-width: none !important;
  flex-shrink: 0 !important;
  padding: var(--spacing-1) var(--spacing-2) !important;
  font-size: var(--type-label-md-font-size) !important;
  font-weight: var(--type-label-md-font-weight) !important;
  border-radius: var(--radius-s) !important;
  box-shadow: none !important;
  line-height: var(--type-label-md-line-height) !important;
  text-align: center !important;
  white-space: nowrap !important;
}

.tClOva[data-variant='secondary'] {
  background-color: var(--surface-neutral-white) !important;
  border: 2px solid var(--surface-primary-medium) !important;
  color: var(--surface-primary-medium) !important;
}

.tClOva[data-variant='secondary']:hover:not(:disabled) {
  background-color: var(--surface-neutral-softer) !important;
}

.tClOva[data-variant='primary'] {
  background-color: var(--surface-primary-medium) !important;
  border: 2px solid var(--surface-primary-medium) !important;
  color: var(--on-surface-neutral-white) !important;
}

.tClOva[data-variant='primary']:hover:not(:disabled) {
  background-color: var(--surface-primary-strong) !important;
  border: 2px solid var(--surface-primary-strong) !important;
}

.tClOva:disabled {
  opacity: var(--opacity-0-5) !important;
  cursor: not-allowed !important;
}

.tdGPpl {
  margin-right: var(--spacing-1, 8px);
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/NewRechargePage/components/Summary/components/TotalValueSection.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,gCAAgC;EAChC,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,iDAAiD;EACjD,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,OAAO;AACT;;AAEA;EACE,iDAAiD;EACjD,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iDAAiD;EACjD,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;EACzB,qDAAqD;EACrD,oDAAoD;EACpD,wDAAwD;EACxD,yCAAyC;EACzC,2BAA2B;EAC3B,wDAAwD;EACxD,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,yDAAyD;EACzD,0DAA0D;EAC1D,+CAA+C;AACjD;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,0DAA0D;EAC1D,0DAA0D;EAC1D,iDAAiD;AACnD;;AAEA;EACE,0DAA0D;EAC1D,0DAA0D;AAC5D;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;AACrC","sourcesContent":[".section {\n  padding: 0;\n  margin: var(--spacing-3, 24px) 0;\n  background: transparent;\n  font-family: var(--font-family-base);\n}\n\n.divider {\n  height: 1px;\n  background-color: #e5e7eb;\n  margin: 24px 0;\n}\n\n.totalRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  gap: 24px;\n  padding: 0 var(--spacing-3, 24px);\n  margin: var(--spacing-3, 24px) 0 0 0;\n}\n\n.totalLabel {\n  font-size: var(--ibk-typography-fontSizeMd, 14px);\n  font-weight: 400;\n  color: #1f2937;\n  white-space: nowrap;\n  flex: 1;\n}\n\n.totalValue {\n  font-size: var(--ibk-typography-fontSizeMd, 14px);\n  font-weight: 600;\n  color: #1f2937;\n  white-space: nowrap;\n}\n\n.checkboxContainer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-shrink: 0;\n  margin-right: 24px;\n}\n\n.checkboxLabel {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font-size: var(--ibk-typography-fontSizeMd, 14px);\n  color: #1f2937;\n  white-space: nowrap;\n}\n\n.checkbox {\n  width: 16px;\n  height: 16px;\n  margin: 0;\n  cursor: pointer;\n}\n\n.checkboxText {\n  user-select: none;\n}\n\n.paymentButton {\n  width: auto !important;\n  min-width: 100px !important;\n  max-width: none !important;\n  flex-shrink: 0 !important;\n  padding: var(--spacing-1) var(--spacing-2) !important;\n  font-size: var(--type-label-md-font-size) !important;\n  font-weight: var(--type-label-md-font-weight) !important;\n  border-radius: var(--radius-s) !important;\n  box-shadow: none !important;\n  line-height: var(--type-label-md-line-height) !important;\n  text-align: center !important;\n  white-space: nowrap !important;\n}\n\n.paymentButton[data-variant='secondary'] {\n  background-color: var(--surface-neutral-white) !important;\n  border: 2px solid var(--surface-primary-medium) !important;\n  color: var(--surface-primary-medium) !important;\n}\n\n.paymentButton[data-variant='secondary']:hover:not(:disabled) {\n  background-color: var(--surface-neutral-softer) !important;\n}\n\n.paymentButton[data-variant='primary'] {\n  background-color: var(--surface-primary-medium) !important;\n  border: 2px solid var(--surface-primary-medium) !important;\n  color: var(--on-surface-neutral-white) !important;\n}\n\n.paymentButton[data-variant='primary']:hover:not(:disabled) {\n  background-color: var(--surface-primary-strong) !important;\n  border: 2px solid var(--surface-primary-strong) !important;\n}\n\n.paymentButton:disabled {\n  opacity: var(--opacity-0-5) !important;\n  cursor: not-allowed !important;\n}\n\n.loadingSpinner {\n  margin-right: var(--spacing-1, 8px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `k0Z7ct`,
	"divider": `oWDs1f`,
	"totalRow": `tI2EMU`,
	"totalLabel": `MOSS1h`,
	"totalValue": `adkx2u`,
	"checkboxContainer": `tl0OMM`,
	"checkboxLabel": `bOPkAg`,
	"checkbox": `JiQ3TS`,
	"checkboxText": `sdtF85`,
	"paymentButton": `tClOva`,
	"loadingSpinner": `tdGPpl`
};
module.exports = ___CSS_LOADER_EXPORT___;
